import angular from 'angular';
import csmCommonWeb from 'csm-common-web';
import addChangeEntityDialog from '../addChangeEntityDialog/addChangeEntityDialog';
import booksSvc from '../../../util/BooksSvc/BooksSvc';
import addChangeVendorDialogTemplate from './addChangeVendorDialogContent.template.html';

export default angular
  .module('books.dialogs.entities.addChangeVendorDialog', [
    csmCommonWeb,
    addChangeEntityDialog,
    booksSvc
  ])
  .controller('VendorDialogController', vendorDialogController)
  .service('AddChangeVendorDialog', addChangeVendorDialogService).name;

/*****************************************************************************
 * Controller: VendorDialogController */
/**
 * @ngdoc  controller
 * @module books.dialogs.entities
 * @name   books.dialogs.entities.addChangeVendorDialog.controller:VendorDialogController
 *
 * @description
 * This is used to manage the modal vendor dialog. Additional injections are
 * done from the $uibModal.open method so they can be passed through to the
 * addChangeEntityContent directive.
 *****************************************************************************/
/* @ngInject */
function vendorDialogController(
  $scope,
  BooksSvc,
  id,
  nameInput,
  SERVER,
  Tools
) {
  /*-----------------------*/
  /* Max Character Lengths */
  /*-----------------------*/
  /** @private */ $scope.MAX_CHARS_TAX_ID = 11;
  /** @private */ $scope.MAX_CHARS_CONTACT_NAME = 50;
  /** @private */ $scope.MAX_CHARS_CONTACT_EMAIL = 50;

  /*****************************************************************************
   * Properties
   *****************************************************************************/
  /** Vendor Validator Control Object. */ $scope.valVendor = {};

  /*---------------------------------------*/
  /* Set pass-through directive properties */
  /*---------------------------------------*/
  $scope.entityID = id;
  $scope.entityType = SERVER.BooksDBConstants.ET_VENDOR;
  $scope.nameInput = nameInput;
  $scope.isDistrictWide = !!SERVER.appFlags.createDistrictWideVendors;
  $scope.readOnly = !!SERVER.appFlags.restrictVendors;

  /*****************************************************************************
   * loadVendor */
  /**
   * Calls the server to load the vendor for the passed id. The service promise
   * is returned.
   *
   * @return  Service promise
   *****************************************************************************/
  $scope.loadVendor = function () {
    return BooksSvc.getVendor(id);
  };

  /*****************************************************************************
   * saveVendor */
  /**
   * Saves the entity vendor object to the database. The service promise is
   * returned.
   *
   * @return  Service promise
   *****************************************************************************/
  $scope.saveVendor = function () {
    return BooksSvc.saveVendor($scope.entity);
  };

  /*****************************************************************************
   * taxRateDisplay */
  /**
   * Converts the display form of the tax rate to a decimal form to save to the
   * entity. When reading the value back, we need to get the display form of the
   * tax rate.
   *
   * @param  value  Tax Rate value from 0 to 100
   *****************************************************************************/
  $scope.taxRateDisplay = function (value) {
    if (!$scope.entity) return;

    if (arguments.length) {
      $scope.entity.taxPercent = value / 100;
    }

    return Tools.roundToPrecision($scope.entity.taxPercent * 100, 2);
  };

  /*---------------------------*/
  /* Initialize data providers */
  /*---------------------------*/
  BooksSvc.getVendorUISettings().then(function (resp) {
    $scope.vendorTypes = resp.data.vendorTypes.concat([
      { name: 'Other', editable: true }
    ]);
    $scope.f1099Types = resp.data.f1099Types;
  });

  /*------------------------------------------------------*/
  /* Set up a watch on the 1099 flag to set the 1099 type */
  /* to the first option when set and not type is set     */
  /*------------------------------------------------------*/
  $scope.$watch('entity.f1099', function (val) {
    if (!$scope.entity) return;

    if (val && !$scope.entity.f1099Type && ($scope.f1099Types || []).length > 0)
      $scope.entity.f1099Type = $scope.f1099Types[0].value;
  });
}

/*****************************************************************************
 * Service: AddChangeVendorDialog */
/**
 * @ngdoc   service
 * @module  books.dialogs.entities
 * @name    books.dialogs.entities.addChangeVendorDialog.service:AddChangeVendorDialog
 *
 * @description
 * This returns an object that will display a modal dialog for managing a
 * vendor's information.
 *****************************************************************************/
/* @ngInject */
function addChangeVendorDialogService($uibModal) {
  /*****************************************************************************
   * show */
  /**
   * Open a modal dialog to manage/create a vendor entity object.
   *
   * @param  id        Vendor ID to load. 0=New
   * @param  nameInput Initial name to set for new vendors
   * @return           Promise object to listen for save success
   *****************************************************************************/
  this.show = function (id, nameInput) {
    return $uibModal.open({
      backdrop: 'static',
      resolve: {
        id: function () {
          return id;
        },
        nameInput: function () {
          return nameInput;
        }
      },
      controller: 'VendorDialogController',
      template: addChangeVendorDialogTemplate
    }).result;
  };
}
